import type { ResumeContent, ResumeSettings } from '@/lib/resume/types';

/**
 * Fixed specimen resume for the /resume-builder hero illustration.
 *
 * Not a real user's data — a realistic placeholder so the preview card reads
 * as an actual resume rather than an empty template. It is rendered through
 * the same `renderResumeHtml()` the builder itself uses (see
 * ResumeBuilderPreviewCard), so the illustration is pixel-identical to what a
 * real resume looks like. Keep this content static: no auth, no API calls.
 */
export const SAMPLE_RESUME_CONTENT: ResumeContent = {
  personalInfo: {
    firstName: 'Sarah',
    lastName: 'Chen',
  },
  profile: {
    headline: 'Senior Product Manager',
    summary:
      'Product leader with 8+ years shipping B2B SaaS platforms from zero to scale. Skilled at turning ambiguous customer problems into roadmaps engineering can execute against.',
  },
  contact: {
    location: 'Austin, TX',
    email: 'sarah.chen@email.com',
    phone: '(512) 555-0148',
  },
  links: [{ id: 'link-linkedin', type: 'linkedin', url: 'linkedin.com/in/sarahchen' }],
  skills: {
    technical: ['Product Strategy', 'Roadmapping', 'SQL', 'A/B Testing', 'Figma'],
    soft: ['Cross-functional Leadership', 'Stakeholder Communication'],
    categories: [],
  },
  employment: [
    {
      id: 'job-northwind',
      title: 'Senior Product Manager',
      company: 'Northwind Analytics',
      location: 'Austin, TX',
      startDate: '2022-03',
      isCurrentlyWorking: true,
      responsibilities:
        '- Led the platform team shipping self-serve analytics to 40,000+ business users\n- Grew activation 28% by redesigning the onboarding flow\n- Partnered with design and engineering to ship three major releases a year',
    },
    {
      id: 'job-brightloop',
      title: 'Product Manager',
      company: 'Brightloop',
      location: 'Austin, TX',
      startDate: '2019-06',
      endDate: '2022-02',
      isCurrentlyWorking: false,
      responsibilities:
        '- Owned the reporting suite from discovery through general availability\n- Cut churn 12% by shipping the integrations customers asked for most',
    },
  ],
  education: [
    {
      id: 'edu-ut',
      institution: 'University of Texas at Austin',
      degree: 'B.S.',
      field: 'Business Administration',
      startDate: '2011-08',
      endDate: '2015-05',
    },
  ],
  certifications: [],
  customSections: [],
};

export const SAMPLE_RESUME_SETTINGS: ResumeSettings = {
  templateId: 'professional',
  colorSchemeId: 'burgundy',
};
